import { createAction } from 'redux-actions'

const ns = 'announcements/'

export const getAnnouncements = createAction(`${ns}GET_ANNOUNCEMENTS`)
export const getAnnouncementsSuccess = createAction(`${ns}GET_ANNOUNCEMENTS_SUCCESS`)
export const getAnnouncementsFail = createAction(`${ns}GET_ANNOUNCEMENTS_FAIL`)

export const getAnnouncementFilters = createAction(`${ns}GET_ANNOUNCEMENT_FILTERS`)
export const getAnnouncementFiltersSuccess = createAction(`${ns}GET_ANNOUNCEMENT_FILTERS_SUCCESS`)
export const getAnnouncementFiltersFail = createAction(`${ns}GET_ANNOUNCEMENT_FILTERS_FAIL`)

export const createAnnouncement = createAction(`${ns}CREATE_ANNOUNCEMENT`)
export const createAnnouncementSuccess = createAction(`${ns}CREATE_ANNOUNCEMENT_SUCCESS`)
export const createAnnouncementFail = createAction(`${ns}CREATE_ANNOUNCEMENT_FAIL`)

export const editAnnouncement = createAction(`${ns}EDIT_ANNOUNCEMENT`)
export const editAnnouncementSuccess = createAction(`${ns}EDIT_ANNOUNCEMENT_SUCCESS`)
export const editAnnouncementFail = createAction(`${ns}EDIT_ANNOUNCEMENT_FAIL`)

export const deleteAnnouncements = createAction(`${ns}DELETE_ANNOUNCEMENTS`)
export const deleteAnnouncementsSuccess = createAction(`${ns}DELETE_ANNOUNCEMENTS_SUCCESS`)
export const deleteAnnouncementsFail = createAction(`${ns}DELETE_ANNOUNCEMENTS_FAIL`)
